// Concept of Sustainability page English translations

export default {
  pageTitle: "Concept of Sustainability",
  breadcrumbHome: "Home",
  breadcrumbSustainability: "Sustainability",
  breadcrumbCurrent: "Concept of Sustainability",
  
  // Header section
  title: "Our Concepts of Sustainability",
  
  // Concept details section
  conceptTitle: "Eagle Industry's Sustainability Concept",
  conceptDesc1: "At Eagle Industry Indonesia, we believe that companies belong to not only their shareholders but also their employees and society. This philosophy has long permeated every aspect of the EKK Group's management since our establishment in 1996.",
  conceptDesc2: "As part of Eagle Industry Co., Ltd., a global leader in sealing solutions, we contribute to environmental protection through our core business. Our mechanical seals prevent gases, oil, and other fluids from leaking machinery, directly helping to preserve the environment and prevent pollution.",
  
  // Sustainability vision section
  visionTitle: "Our Sustainability Vision",
  visionDesc: "We aim to create sustainable value for all stakeholders by integrating environmental, social, and governance (ESG) considerations into our business strategy. Our vision is to be a trusted partner that contributes to society through innovative sealing solutions while maintaining harmony with the global environment.",
  
  // Core principles section
  principlesTitle: "Core Sustainability Principles",
  principle1Title: "Environmental Protection",
  principle1Desc: "Through leak prevention technology",
  principle2Title: "Building Trust",
  principle2Desc: "Through dialogue with all stakeholders",
  principle3Title: "Fair Profits",
  principle3Desc: "That support perpetual growth",
  principle4Title: "Product Development",
  principle4Desc: "That resolves environmental regulatory issues",
  principle5Title: "Human Rights",
  principle5Desc: "And occupational health and safety",
  principle6Title: "Community Contribution",
  principle6Desc: "And biodiversity conservation",
  
  // Long-term goals section
  goalsTitle: "Long-Term Sustainability Goals",
  goalsDesc: "We have established long-term goals aligned with global sustainability frameworks, including the UN Sustainable Development Goals (SDGs) and the Paris Agreement. Our commitment extends beyond compliance to proactive leadership in sustainable business practices.",
  
  // Quote section
  quoteText: "Sustainability is not just a responsibility but an opportunity to innovate and create lasting value for our stakeholders and society.",
  quoteAuthor: "Management, Eagle Industry Indonesia",
  
  // Sustainability pillars section
  pillarsTitle: "Our Sustainability Pillars",
  pillarsSubtitle: "The core elements of our sustainability framework",
  pillar1Title: "Environmental",
  pillar1Desc: "Minimizing environmental impact through innovative products and processes that prevent pollution and conserve resources.",
  pillar2Title: "Social",
  pillar2Desc: "Creating value for society through responsible business practices, employee development, and community engagement.",
  pillar3Title: "Governance",
  pillar3Desc: "Maintaining high standards of corporate governance to ensure transparency, accountability, and ethical business conduct.",
  
  // Related topics section
  relatedTitle: "Related Sustainability Topics",
  relatedSubtitle: "Explore more about our sustainability initiatives",
  related1Title: "Environmental Initiatives",
  related2Title: "Social Contribution Initiatives",
  related3Title: "Occupational Health & Safety"
};